export const pathTitleMap = {
	project: { label: 'Progetti', page: 'projects' },
};

export type TabTitles = 'dashboard' | 'candidacy' | 'planning' | 'execution' | 'summary' | 'advancement' | 'reporting';
export type TabSubtitles = 'economic' | 'physical';

export const tabTitleMap: Record<TabTitles, string> = {
	dashboard: 'Dashboard',
	candidacy: 'Candidatura',
	planning: 'Pianificazione',
	execution: 'Avanzamento',
	summary: 'Controllo',
	advancement: 'Monitoraggio',
	reporting: 'Rendicontazione',
};

export const tabTitleMapGuestEnteErogante: Record<TabTitles, string> = {
	dashboard: 'Dashboard',
	candidacy: 'Candidatura',
	planning: 'Pianificazione',
	execution: 'Avanzamento',
	summary: 'Controllo',
	advancement: 'Monitoraggio',
	reporting: 'Controllo rendicontazione',
};

export const submenuTitleMap: Record<TabSubtitles, string> = {
	economic: 'Economico',
	physical: 'Fisico',
};

export const tabDescriptionMap = {
	dashboard:
		'Consulta una panoramica sintetica del progetto: visualizza grafici aggiornati sullo stato di avanzamento economico e accedi rapidamente ai dati anagrafici principali.',
	candidacy:
		'Compila i dati richiesti per presentare la candidatura, definisci il quadro economico e inserisci i target progettuali previsti.',
	planning:
		'Organizza il budget distribuendo le risorse in base alle esigenze progettuali. Configura le voci di spesa e pianifica la struttura finanziaria del progetto.',
	execution: {
		economic:
			'Carica la documentazione contabile e inserisci i dati necessari per monitorare correttamente l’avanzamento economico del progetto.',
		physical: 'Inserisci la documentazione e aggiorna le informazioni utili a tracciare l’avanzamento fisico delle attività progettuali.',
	},
	summary:
		'Verifica la documentazione caricata, monitora la conformità del progetto rispetto alle regole amministrative e finanziarie e segnala eventuali criticità.',
	advancement:
		'Monitora l’avanzamento procedurale, finanziario e fisico del progetto. Genera gli output personalizzati, aggiorna lo stato delle attività e consulta i grafici riepilogativi nelle aree dedicate.',
	reporting:
		'Redigi e trasmetti i rendiconti secondo gli obblighi normativi previsti. Consulta lo storico delle rendicontazioni già inviate e verifica lo stato di approvazione.',
};
